// extracted by mini-css-extract-plugin
export default {"surface":"styles_surface__-pNrE","surface-border":"styles_surface-border__atFnM","video":"styles_video__hK0z4"};